//import 'fancybox/dist/js/jquery.fancybox.pack'
import '@fancyapps/fancybox/dist/jquery.fancybox.min.js'

$(document).ready(function() {
  dhsv_vc_download()
})

function dhsv_vc_download() {}
